<template>
	<TVAlert
		v-if="alertVisible"
		:detail="alertMessage"
		severity="error"
		:customClass="'custom-alert'"
	/>
	<router-view></router-view>
	<Preloader :showModal="showM" />

	<!-- Modal Verification Code -->
	<Modal
		class="verification-code"
		v-if="showCodeDialog"
		dialogStyle="login-modal"
	>
		<template v-slot:body>
			<transition name="fade">
				<p v-if="dialogMessage3 && !dialogMessage4" class="resend-code">
					<span class="material-symbols-outlined" translate="no"
						>check_circle</span
					>
					{{ dialogMessage3 }} {{ attemptedEmail }}
					<button @click="dialogMessage3 = false" class="close">
						<span class="material-symbols-outlined" translate="no">close</span>
					</button>
				</p>
			</transition>
			<transition name="fade">
				<p v-if="dialogMessage4" class="error resend-code">
					<span class="material-symbols-outlined" translate="no">cancel</span>
					{{ dialogMessage4 }}
					<button @click="dialogMessage4 = false" class="close">
						<span class="material-symbols-outlined" translate="no">close</span>
					</button>
				</p>
			</transition>
			<span class="material-symbols-outlined" translate="no">password</span>
			<h1 class="title">{{ dialogMessage }}</h1>
			<p class="desc1">{{ dialogMessage2 }}</p>
			<OTPInput
				@otp-entered="handleOtpEntered"
				:resetOtp="resetOtp"
				:label="$t('register.verificationCode')"
				:helperText="$t('verifiCode.label2')"
				:isInvalid="dialogErrorMesssage"
				:invalidText="dialogErrorMesssage"
			/>
		</template>
		<template v-slot:footer>
			<TVButtonBase
				:value="$t('verifiCode.submit')"
				variant="primary"
				size="md"
				type="button"
				@click="submitNewCode"
			/>
			<p>
				{{ $t('register.didntCode') }}
				<a @click="submitRequestNewCode">{{ $t('verifiCode.text4') }}</a>
			</p>
		</template>
	</Modal>
</template>

<script>
/* eslint-disable */
import { Hub, Logger } from 'aws-amplify'
import { Auth } from '@aws-amplify/auth'
import {
	computed,
	getCurrentInstance,
	onMounted,
	onUnmounted,
	ref,
} from '@vue/runtime-core'
import store from '@/store'
import router from '@/router'
import { useRoute } from 'vue-router'
import {
	getUserByEmail,
	registerUserBasicStep,
	translateText,
} from '@/plugins/authUtils'
import { GeneralHelper } from '@/plugins/helpers'
import axios from 'axios'
import { useAuthErrorMapper } from '@/composables/useAuthErrorMapper'

import Preloader from '@/components/Preloader'
import { i18n } from '@/plugins/i18n'
import { ActiveStatus } from '../src/utils/to_hidde'
import Modal from '@/components/Modal'
import OTPInput from '../src/components/settings_new/atoms/OTPInput.vue'
import TVButtonBase from '../modules/ui/TVButtonBase.vue'
import TVAlert from '../modules/global/TVAlert.vue'

const logger = new Logger('main')

export default {
	name: 'app',
	components: {
		Preloader,
		Modal,
		OTPInput,
		TVButtonBase,
		TVAlert,
	},
	data() {
		return {
			authUser: null,
		}
	},
	setup() {
		const { alertMessage, alertVisible, showAuthAlert } = useAuthErrorMapper()
		/* ===============================
       REFS Y VARIABLES REACTIVAS
    ================================ */
		const ib = ref(null)
		const ib_tree = ref(null)
		const entityOptions = ref(null)
		const region = ref(process.env.VUE_APP_CABINET_ORIGIN)
		const route = useRoute()
		const showM = ref(false)
		const userObj = ref(null)
		const msgs = ref([])
		const showCodeDialog = ref(false)
		const newCode = ref('')
		const resetOtp = ref(false)
		const dialogMessage = ref(null)
		const dialogMessage2 = ref(null)
		const dialogMessage3 = ref(null)
		const dialogMessage4 = ref(null)
		const emailUser = ref(null)
		const dialogErrorMesssage = ref(null)
		const attemptedEmail = ref(null)
		const currentPassword = ref(null)

		// Obtenemos el emitter desde el contexto global
		const internalInstance = getCurrentInstance()
		const emitter = internalInstance.appContext.config.globalProperties.emitter

		/* ===============================
       GESTIÓN DE EVENTOS DE AUTH (AWS Amplify)
    ================================ */
		Hub.listen('auth', (data) => {
			if (data.payload.event === 'tokenRefresh_failure') {
				console.error('critical: ' + data.payload.event)
				return
			}

			checkAuthUser()
			store.commit('setLoginEvent', data.payload.event)

			switch (data.payload.event) {
				case 'signIn':
					showM.value = false
					if (data.payload.data.hasOwnProperty('attributes')) {
						emitter.emit('authStateUpdated', {
							email: data.payload.data.attributes.email,
							state: 'LOGGED_IN',
						})
					}
					break
				case 'signUp':
					showM.value = false
					emitter.emit('authStateUpdated', {
						email: data.payload.data.user.username,
						state: 'REGISTERED',
					})
					break
				case 'signOut':
					showM.value = false
					store.commit('setLoginEvent', 'LOGGED_OUT')
					localStorage.removeItem('storedAccounts')
					localStorage.removeItem('typeAccount')
					localStorage.removeItem('activeAccount')
					localStorage.removeItem('userEntity')
					localStorage.removeItem('userCountryByIp')
					emitter.emit('authStateUpdated', { state: 'LOGGED_OUT' })
					break
				case 'signIn_failure':
				case 'configured':
				case 'forgotPasswordSubmit':
				case 'tokenRefresh_failure':
					break
				default:
					break
			}
		})

		/* ===============================
       FUNCIONES AUXILIARES
    ================================ */
		const fetchLocalIP = async () => {
			try {
				const response = await fetch('https://dcsz5gywka2h4.cloudfront.net/')
				if (!response.ok) {
					throw new Error('Network response was not ok')
				}
				const text = await response.text()
				return text
			} catch (error) {
				console.error('Error fetching data:', error)
				return undefined
			}
		}

		const getIbandIbTree = () => {
			ib.value = localStorage.getItem('ib_id')
			ib_tree.value = localStorage.getItem('ib_tree')

			if (
				(ib.value == null || ib.value === 'undefined') &&
				(ib_tree.value == null || ib_tree.value === 'undefined')
			) {
				localStorage.setItem('ib_id', route.query.ib)
				localStorage.setItem('ib_tree', route.query.ib_tree)
				ib.value = localStorage.getItem('ib_id')
				ib_tree.value = localStorage.getItem('ib_tree')
			} else {
				if (route.query.ib) {
					localStorage.setItem('ib_id', route.query.ib)
					ib.value = route.query.ib
				} else {
					const storedIb = localStorage.getItem('ib_id')
					ib.value =
						storedIb !== null && storedIb !== 'undefined'
							? storedIb
							: 'undefined'
				}

				if (route.query.ib_tree) {
					localStorage.setItem('ib_tree', route.query.ib_tree)
					ib_tree.value = route.query.ib_tree
				} else {
					const storedIbTree = localStorage.getItem('ib_tree')
					ib_tree.value =
						storedIbTree !== null && storedIbTree !== 'undefined'
							? storedIbTree
							: 'undefined'
				}
			}
		}

		const getEntityUrl = () => {
			localStorage.setItem('entityOptions', route.query.ent)
			entityOptions.value = localStorage.getItem('entityOptions')
		}

		/* ===============================
       FUNCIONES DE AUTENTICACIÓN Y NEGOCIO
    ================================ */
		const doAuthenticatedUser = async (email) => {
			showM.value = true

			let userInfo = await getUserByEmail(email).catch((error) => {
				logger.error(error)
			})

			if (userInfo?.pending?.files) {
				router.push({
					path: `/cabinet/console/expired_documents/${userInfo.pending.files.toLowerCase()}`,
				})
			}

			if (!userInfo) {
				userInfo = await registerUserBasicStep(ib.value, ib_tree.value)
				emitter.emit('userRegistered')
			}

			if (userInfo) {
				store.commit('setUser', userInfo)
				emitter.emit('userUpdated')

				// Cambiar idioma según configuración almacenada
				let langHtmlElement = document.documentElement
				let pageLang = localStorage.getItem('language')
				langHtmlElement.setAttribute('lang', pageLang || 'en')
				langHtmlElement.setAttribute('dir', pageLang === 'ar' ? 'rtl' : 'ltr')

				// Obtener país del usuario por IP
				try {
					showM.value = true
					if (ActiveStatus.includes(userInfo?.registerStatus)) {
						console.log('usuarios con cuentas live cargados')
					}
					let userCountryByIp = await fetchLocalIP()
					if (userCountryByIp) {
						localStorage.setItem('userCountryByIp', userCountryByIp)
					}
					showM.value = false
				} catch (error) {
					console.error(error)
					showM.value = false
				}

				// Configurar atributos del HTML
				let htmlElement = document.documentElement
				htmlElement.setAttribute(
					'cabinet-origin',
					process.env.VUE_APP_CABINET_ORIGIN,
				)
				htmlElement.setAttribute('theme', 'light')

				// Proceso de aplicación
				if (userInfo.applicationID) {
					let application = 'Application Done'
					if (!application) {
						application = await createAndAssignAnApplicationProcess(
							userInfo,
							'INDIVIDUAL',
						).catch((error) => {
							logger.error(error)
						})
					}
					if (application) {
						store.commit('setApplication', application)
						emitter.emit('applicationUpdated')
					}
				}
				emitter.emit('userSet')

				let routerChanger = window.location.pathname
					.replace(/\/$/, '')
					.split('/')
					.pop()
				let statusUser = userInfo.registerStatus

				if (statusUser != null) {
					switch (statusUser) {
						case 'AT_PASSWORD': {
							const currentPath = window.location.pathname
							let containsRegisterIBPortal =
								currentPath.includes('register_ib_portal')

							if (!containsRegisterIBPortal) {
								let accountRegis =
									localStorage.getItem('typeAccount') || 'live-account'
								let ibId = localStorage.getItem('ib_id')
								let ibTree = localStorage.getItem('ib_tree')
								let finalUrl = '/register/2/' + accountRegis
								if (ibId && ibId !== 'undefined') finalUrl += `?ib=${ibId}`
								if (ibTree && ibTree !== 'undefined')
									finalUrl += `?ib_tree=${ibTree}`
								router.replace(finalUrl).catch((error) => {
									logger.error(error)
								})
							} else {
								let accountRegis =
									localStorage.getItem('typeAccount') || 'live-account'
								let finalUrl = '/register_ib_portal/2/' + accountRegis
								router.replace(finalUrl).catch((error) => {
									logger.error(error)
								})
							}
							break
						}
						case 'INACTIVE':
							await Auth.signOut()
							break
						default:
							switch (routerChanger) {
								case 'login':
								case 'login_ib_portal':
									routerChanger =
										statusUser === 'AT_DETAILS'
											? '/cabinet/console/welcome'
											: ActiveStatus.includes(statusUser)
												? '/cabinet/console/platforms'
												: '/cabinet/console/application-process'
									break
								case 'live-account':
									routerChanger =
										statusUser === 'AT_DETAILS'
											? '/cabinet/console/welcome'
											: ActiveStatus.includes(statusUser)
												? '/cabinet/console/platforms'
												: '/cabinet/console/application-process'
									break
								case 'demo-account':
									routerChanger =
										statusUser === 'AT_DETAILS'
											? '/cabinet/console/create_new_demo_account'
											: ActiveStatus.includes(statusUser)
												? '/cabinet/console/platforms'
												: '/cabinet/console/application-process'
									break
								case 'reset-password':
									routerChanger = ['shareholder', 'secondary'].includes(
										userInfo.role,
									)
										? '/cabinet/console/application-process'
										: '/register/2/' +
											(localStorage.getItem('typeAccount') || 'live-account')
									break
							}
							router.replace(routerChanger).catch((error) => {
								logger.error(error)
							})
							break
					}
					localStorage.setItem('activeAccount', userInfo.registerStatus)
				}
				showM.value = false
			} else {
				throw 'CRITICAL ERROR: Contact tech team!'
			}
		}

		const checkAuthUser = () => {
			Auth.currentAuthenticatedUser()
				.then((user) => {
					store.commit('setToken', user.signInUserSession.idToken.getJwtToken())
					doAuthenticatedUser(user.attributes.email)
				})
				.catch((err) => {
					let langHtmlElement = document.documentElement
					let pageLang = localStorage.getItem('language')
					langHtmlElement.setAttribute('lang', pageLang || 'en')
					langHtmlElement.setAttribute('dir', pageLang === 'ar' ? 'rtl' : 'ltr')
					console.log(err)
					store.commit('clearUser')
				})
		}

		const signOut = async () => {
			await Auth.signOut()
			emitter.emit('successfulRequest')
		}

		const federatedSignIn = async (params) => {
			showM.value = true
			Auth.federatedSignIn({ provider: params.provider })
		}

		const signIn = async (email, password) => {
			showM.value = true;

			try {
				const user = await Auth.signIn(email, password);
				userObj.value = user;

				if (!user || typeof user.challengeName === 'undefined') {
					console.warn('⚠️ user.challengeName no definido:', user);
				}


				switch (user.challengeName) {
					case 'NEW_PASSWORD_REQUIRED':
						showM.value = false;
						localStorage.setItem('TEMP_U', JSON.stringify({ email, password }));
						router.push({ path: '/reset-password' });
						return;

					case 'SOFTWARE_TOKEN_MFA':
					case 'SMS_MFA':
						showM.value = false;
						emitter.emit('showTOTPDialog', i18n.global.t('register.mfaCode'));
						return;

					default:
						showM.value = false;

						// Envolver doAuthenticatedUser en try/catch separado
						try {
							await doAuthenticatedUser(user.attributes.email);
						} catch (error) {
							logger.error('❌ Error en doAuthenticatedUser:', error);
							return; // evita seguir si falla
						}

						const statusUser = store.state.user?.registerStatus;
						if (!statusUser) {
							console.warn('⚠️ statusUser no disponible después de doAuthenticatedUser');
							return;
						}

						let routerChanger = window.location.pathname.replace(/\/$/, '').split('/').pop();

						try {
							switch (statusUser) {
								case 'AT_PASSWORD': {
									let accountRegis = localStorage.getItem('typeAccount') || 'live-account';
									router.replace('/register/2/' + accountRegis).catch((error) => {
										logger.error(error);
									});
									break;
								}
								case 'INACTIVE':
									await Auth.signOut();
									break;
								default:
									switch (routerChanger) {
										case 'login':
										case 'login_ib_portal':
										case 'live-account':
											routerChanger =
												statusUser === 'AT_DETAILS'
													? '/cabinet/console/welcome'
													: ActiveStatus.includes(statusUser)
													? '/cabinet/console/platforms'
													: '/cabinet/console/application-process';
											break;
										case 'demo-account':
											routerChanger =
												statusUser === 'AT_DETAILS'
													? '/cabinet/console/create_new_demo_account'
													: ActiveStatus.includes(statusUser)
													? '/cabinet/console/platforms'
													: '/cabinet/console/application-process';
											break;
									}
									router.replace(routerChanger).catch((error) => {
										logger.error(error);
									});
							}
						} catch (error) {
							logger.error('❌ Error en lógica de redirección:', error);
						}
				}
			} catch (e) {
				console.error(e);
				if (e.message?.includes('reset')) {
					router.push('/forgot');
				}

				showM.value = false;

				if (e.message === 'User is not confirmed.') {
					logger.info('📩 Usuario no confirmado, emitiendo requestNewCode');
					emitter.emit('requestNewCode', { email, password });
				} else {
					showAuthAlert(e, 'login');
				}
			}
		};


		const signUp = async (email, password, disclaimer) => {
			attemptedEmail.value = email
			currentPassword.value = password
			let username = email
			showM.value = true
			try {
				const { user } = await Auth.signUp({
					username,
					password,
					disclaimer,
					attributes: { email },
				})
				emitter.emit('successfulRequest')
			} catch (error) {
				showM.value = false
				showAuthAlert(error, 'register')
				emitter.emit('failedRequest', error)

				const currentPath = window.location.pathname
				let containsRegisterIBPortal =
					currentPath.includes('register_ib_portal')

				setTimeout(() => {
					if (containsRegisterIBPortal) {
						localStorage.setItem('isIbportal', true)
						router.push({
							path: `/login_ib_portal`,
						})
					}
				}, 2000)
			}
		}

		const requestNewCode = async (email, password) => {
			try {
				Auth.resendSignUp(email)
					.then(() => {
						if (store.state.loginFlow === 'LOGIN') {
							attemptedEmail.value = email
							currentPassword.value = password
							emitter.emit('showCodeDialog', i18n.global.t('verifiCode.title'))
							emitter.emit('showCodeDialog2', i18n.global.t('verifiCode.text2'))
							emitter.emit('showCodeDialog3', i18n.global.t('register.newCode'))
						} else {
							emitter.emit('showCodeDialog3', i18n.global.t('register.newCode'))
						}
						emitter.emit('successfulRequest')
					})
					.catch((error) => {
						showAuthAlert(error, 'register')
						emitter.emit('failedRequest')
					})
			} catch (error) {
				showAuthAlert(error, 'register')
				emitter.emit('failedRequest')
			}
		}

		const requestConfirmSignUp = async (email, newCode) => {
			showM.value = true
			try {
				Auth.confirmSignUp(email, newCode)
					.then(() => {
						showM.value = false
						emitter.emit('showDialog', i18n.global.t('register.registering'))
						emitter.emit('closeAllLoginDialogs')
						emitter.emit('closeAllRegisterDialogs')
						emitter.emit('successfulRequest')
						router
							.replace('/register/2/' + localStorage.getItem('typeAccount'))
							.catch((error) => {
								console.error(error)
							})
					})
					.catch((error) => {
						showM.value = false
						emitter.emit('showCodeDialogErrorMessageAtLogin', error.message)
						emitter.emit('failedRequest')
						showAuthAlert(error, 'register')
					})
			} catch (error) {
				showM.value = false
				emitter.emit('showDialog', error.message)
				emitter.emit('failedRequest')
				showAuthAlert(error, 'register')
			}
		}

		const requestConfirmSignUpAndLogin = async (email, newCode, pass) => {
			showM.value = true
			try {
				Auth.confirmSignUp(email, newCode)
					.then(() => {
						emitter.emit('closeAllLoginDialogs')
						emitter.emit('closeAllRegisterDialogs')
						showM.value = false
						showCodeDialog.value = false
						return Auth.signIn(email, pass)
					})
					.then(() => {
						emitter.emit('successfulRequest')
						showM.value = false
					})
					.catch((error) => {
						showAuthAlert(error, 'register')
						emitter.emit('showCodeDialogErrorMessage', error.message)
						emitter.emit('failedRequest')
						showM.value = false
					})
			} catch (error) {
				emitter.emit('showDialog', error.message)
				emitter.emit('failedRequest')
				showM.value = false
				showAuthAlert(error, 'register')
			}
		}

		const requestForgotPassword = async (email) => {
			Auth.forgotPassword(email)
				.then((data) => {
					showM.value = false
					emitter.emit(
						'showForgotDialog',
						i18n.global.t('register.instructions'),
					)
					emitter.emit('successfulRequest')
				})
				.catch((error) => {
					emitter.emit('showDialog', error.message)
					emitter.emit('failedRequest')
					showAuthAlert(error, 'resetPassword')
				})
		}

		const requestTOTPLogin = async (totpCode) => {
			Auth.confirmSignIn(
				userObj.value,
				totpCode.value.toString(),
				userObj.value.challengeName,
			)
				.then(() => {
					showM.value = false
					emitter.emit('successfulRequest')
				})
				.catch((e) => {
					emitter.emit('showDialog', e.message)
					emitter.emit('failedRequest')
					showAuthAlert(e, 'resetPassword')
				})
		}

		const createAndAssignAnApplicationProcess = (user, accountType) =>
			new Promise((resolve, reject) => {
				let applicationProcess
				showM.value = true
				let _url =
					process.env.VUE_APP_CABINET_V2_API_HOST_DEMO + '/demoaccount/create'
				let _headers = {
					'Content-Type': 'application/json',
					Accept: 'application/json',
					Authorization: 'Bearer ' + store.state.token,
				}
				let _data = {
					applicationType: accountType,
					disclaimer: true,
				}

				axios({ method: 'POST', url: _url, data: _data, headers: _headers })
					.then((result) => {
						let item = result.data.updateUser
						if (item != null) {
							resolve(applicationProcess)
							showM.value = false
						} else {
							showM.value = false
							logger.error('ERROR: unable to update the user record')
							reject('ERROR: unable to update the user record')
						}
					})
					.catch((error) => {
						logger.error(error)
						reject(error)
					})
			})

		/* ===============================
       FUNCIONES PARA MANEJAR OTP Y SUBMISIÓN
    ================================ */

		const handleOtpEntered = (code) => {
			newCode.value = code.trim()
		}

		const submitNewCode = () => {
			try {
				if (currentPassword.value) {
					emitter.emit('requestConfirmSignUpAndLogin', {
						email: attemptedEmail.value,
						newCode: newCode.value,
						password: currentPassword.value,
					})
				} else {
					emitter.emit('requestConfirmSignUp', {
						email: attemptedEmail.value,
						newCode: newCode.value,
					})
				}
			} catch (error) {
				console.log('error', error)
			}
			resetOtp.value = true // Activa el reseteo
			setTimeout(() => (resetOtp.value = false), 100)
		}

		const submitRequestNewCode = () => {
			resetOtp.value = true // Activa el reseteo
			setTimeout(() => (resetOtp.value = false), 100) // Restaura el estado

			dialogErrorMesssage.value = null
			requestNewCode(attemptedEmail.value, currentPassword.value)
		}

		/* ===============================
       CICLO DE VIDA: onMounted y onUnmounted
    ================================ */
		onMounted(() => {
			setTimeout(() => {
				getIbandIbTree()
				getEntityUrl()
			}, 1000)

			// Eventos para refrescar datos y usuario
			emitter.on('requestUserRefresh', () => {
				checkAuthUser()
			})
			emitter.on('doAuthenticatedUser', (user) => {
				doAuthenticatedUser(user)
			})
			emitter.on('requestApplicationRefresh', () => {
				let application = store.state.application
				showM.value = true
				if (application !== null) {
					store.commit('setApplication', application)
					emitter.emit('applicationUpdated')
					showM.value = false
				}
			})

			// Eventos de autenticación
			emitter.on('requestSignIn', (params) => {
				signIn(params.email.toLowerCase(), params.password)
			})
			emitter.on('requestSignUp', (params) => {
				signUp(params.email.toLowerCase(), params.password, params.disclaimer)
			})
			emitter.on('requestSignOut', () => {
				signOut()
			})
			emitter.on('requestRegister', (params) => {
				signUp(params.email.toLowerCase(), params.password)
			})
			emitter.on('requestNewCode', async (params) => {
				await requestNewCode(params.email, params.password)
			})
			emitter.on('requestTOTPLogin', (params) => {
				requestTOTPLogin(params.totpCode)
			})
			emitter.on('requestConfirmSignUp', (params) => {
				requestConfirmSignUp(params.email, params.newCode)
			})
			emitter.on('requestConfirmSignUpAndLogin', (params) => {
				requestConfirmSignUpAndLogin(
					params.email,
					params.newCode,
					params.password,
				)
			})
			emitter.on('requestForgotPassword', (params) => {
				requestForgotPassword(params.email)
			})
			emitter.on('federatedSignIn', (params) => {
				federatedSignIn(params)
			})
			emitter.on('showDialog', (message) => {
				dialogMessage.value = message
			})
			emitter.on('showDialog2', (message) => {
				dialogMessage.value = message
			})
			emitter.on('showDialog4', (message) => {
				dialogMessage4.value = message
			})
			emitter.on('showCodeDialog', (message) => {
				dialogMessage.value = message
				dialogErrorMesssage.value = null
				showCodeDialog.value = true
			})
			emitter.on('showCodeDialog2', (message) => {
				dialogMessage2.value = message
				dialogErrorMesssage.value = null
				showCodeDialog.value = true
			})
			emitter.on('showCodeDialog3', (message) => {
				dialogMessage3.value = message
				dialogErrorMesssage.value = null
				showCodeDialog.value = true
			})
			emitter.on('showCodeDialogErrorMessage', (message) => {
				dialogErrorMesssage.value = message
			})

			checkAuthUser()
		})

		onUnmounted(() => {
			emitter.off('requestApplicationRefresh')
			emitter.off('requestUserRefresh')
			emitter.off('requestSignIn')
			emitter.off('requestSignUp')
			emitter.off('requestSignOut')
			emitter.off('requestRegister')
			emitter.off('requestNewCode')
			emitter.off('requestConfirmSignUp')
			emitter.off('requestConfirmSignUpAndLogin')
			emitter.off('requestForgotPassword')
			emitter.off('requestTOTPLogin')
			emitter.off('showCodeDialog')
			emitter.off('showCodeDialog2')
			emitter.off('showCodeDialog3')
			emitter.off('showCodeDialogErrorMessage')
			emitter.off('showDialog')
			emitter.off('showCodeDialog')
			emitter.off('showCodeDialogErrorMessage')
		})

		/* ===============================
       RETORNO DE VARIABLES Y FUNCIONES AL TEMPLATE
    ================================ */
		return {
			checkAuthUser,
			getUserByEmail,
			registerUserBasicStep,
			showM,
			msgs,
			region,
			getIbandIbTree,
			getEntityUrl,
			showCodeDialog,
			dialogMessage,
			dialogMessage2,
			dialogMessage3,
			dialogMessage4,
			emailUser,
			newCode,
			dialogErrorMesssage,
			handleOtpEntered,
			submitNewCode,
			submitRequestNewCode,
			attemptedEmail,
			requestConfirmSignUpAndLogin,
			alertMessage,
			alertVisible,
		}
	},
}
</script>

<style lang="scss">
@use 'assets/css/style';
</style>
